/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, November 22nd 2021, 2:08:12 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */
import {
  APIMany2ManyTransferListFormInput,
  ConcreteAPIMany2ManyTransferListFormInputProps,
  APIMany2ManyCheckBoxFormInput,
  ConcreteAPIMany2ManyInputProps,
  APIMany2OneSelectFormInput,
  ConcreteAPIMany2OneSelectFormInputProps,
} from "ui-widgets";
import { Portal } from "lib/schemas";
import { APISERVICEPATHS } from "lib/api";
import ListItemText from "@mui/material/ListItemText";
import LanguageIcon from "@mui/icons-material/Language";

export const PortalsTransferListInput = <T,>(props: ConcreteAPIMany2ManyTransferListFormInputProps<T, Portal>) => (
  <APIMany2ManyTransferListFormInput<T, Portal>
    apiServicePath={APISERVICEPATHS.portals}
    itemIdProperty="id"
    getOptionComponent={(option) => <ListItemText primary={option.name} secondary={option.domain} />}
    {...props}
  />
);

export const PortalsCheckboxesInput = <T,>(props: ConcreteAPIMany2ManyInputProps<T, Portal>) => (
  <APIMany2ManyCheckBoxFormInput<T, Portal>
    apiServicePath={APISERVICEPATHS.portals}
    itemIdProperty="id"
    getOptionComponent={(option) => <ListItemText primary={option.name} secondary={option.domain} />}
    {...props}
  />
);

export const SinglePortalSelectInput = <T,>(props: ConcreteAPIMany2OneSelectFormInputProps<T, Portal>) => (
  <APIMany2OneSelectFormInput<T, Portal>
    apiServicePath={APISERVICEPATHS.portals}
    itemIdProperty="id"
    label={props.label ?? "Select Portal"}
    getOptionLabel={(option) => `${option.name} (${option.domain})`}
    inputStartAdornment={<LanguageIcon color="primary" />}
    {...props}
  />
);
